"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KpiAlertDialogWrapper = void 0;
var tslib_1 = require("tslib");
// (C) 2021-2022 GoodData Corporation
var react_1 = tslib_1.__importStar(require("react"));
var react_intl_1 = require("react-intl");
var model_1 = require("../../../../model");
var KpiAlerts_1 = require("./KpiAlerts");
var useBrokenAlertFiltersMeta_1 = require("./useBrokenAlertFiltersMeta");
exports.KpiAlertDialogWrapper = function (props) {
    var brokenAlertFiltersBasicInfo = props.brokenAlertFiltersBasicInfo, backend = props.backend, workspace = props.workspace, restProps = tslib_1.__rest(props, ["brokenAlertFiltersBasicInfo", "backend", "workspace"]);
    var intl = react_intl_1.useIntl();
    var dateDatasets = model_1.useDashboardSelector(model_1.selectCatalogDateDatasets);
    var _a = useBrokenAlertFiltersMeta_1.useBrokenAlertFiltersMeta({
        dateDatasets: dateDatasets,
        backend: backend,
        workspace: workspace,
        brokenAlertFilters: brokenAlertFiltersBasicInfo,
    }), brokenAlertFiltersMeta = _a.result, status = _a.status;
    var brokenAlertFilters = react_1.useMemo(function () {
        if (!brokenAlertFiltersMeta) {
            return null;
        }
        return KpiAlerts_1.enrichBrokenAlertsInfo(brokenAlertFiltersBasicInfo, intl, restProps.dateFormat, brokenAlertFiltersMeta.dateDatasets, brokenAlertFiltersMeta.attributeFiltersMeta);
    }, [brokenAlertFiltersBasicInfo, brokenAlertFiltersMeta, intl, restProps.dateFormat]);
    return (react_1.default.createElement(KpiAlerts_1.KpiAlertDialog, tslib_1.__assign({}, restProps, { isAlertDialogOpening: status === "loading", brokenAlertFilters: brokenAlertFilters })));
};
//# sourceMappingURL=KpiAlertDialogWrapper.js.map